import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const TaskTemplateItemDialogTourConfig: AgTechTourConfig = {
    id: 'task-template-item-dialog-tour',
    name: 'Template Item Tour',
    steps: [
        {
            targetId: 'task-item-name',
            title: 'Task Name',
            description: 'The name the planning task will have once the template is applied to a sale.',
            position: 'bottom',
        },
        {
            targetId: 'task-item-description',
            title: 'Description',
            description: 'Optional details about what needs to be done.',
            position: 'bottom',
        },
        {
            targetId: 'task-item-priority',
            title: 'Priority and Reminders',
            description: 'Set the priority and how many days should pass between reminder notifications for this task.',
            position: 'bottom',
        },
        {
            targetId: 'task-item-offsets',
            title: 'Schedule Offsets',
            description: 'Set when the task starts and ends as a number of days from the sale start date. Use negative numbers for days before the sale.',
            position: 'top',
        },
    ]
}
